export default {
  title: 'Nova marca',
  tabs: {
    general: 'Geral',
    branding: 'Marca',
    scripts: 'Scripts',
    tracking: 'Rastreamento',
    domain: 'Domínio',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Nome da marca',
    },
    slug: {
      label: 'Subdomínio',
      placeholder: 'Subdomínio da marca',
      hint: 'Letras minúsculas, números e hífenes. Juntamente com o domínio da loja, forma o endereço da loja.',
      preview: 'Endereço da loja: {{url}}',
      availability: {
        taken: 'Outra marca já usa este subdomínio neste domínio da loja.',
        reserved: 'Este subdomínio está reservado. Escolha outro.',
        invalid_label:
          'Neste domínio da loja, o subdomínio só pode ter letras minúsculas, números e hífenes, tem de começar e terminar com uma letra ou um número e pode ter no máximo 63 caracteres.',
        taken_elsewhere: 'Uma marca noutro domínio da loja já usa este subdomínio. Escolha outro.',
        format: 'Utilize apenas letras, números, hífenes e sublinhados.',
        unavailable: 'Este subdomínio não está disponível. Escolha outro.',
      },
    },
    shop_domain_id: {
      label: 'Domínio da loja',
      placeholder: 'Selecionar um domínio da loja',
      move_warning: {
        title: 'Isto altera o endereço da loja que os clientes utilizam',
        description:
          'Depois de guardar, a loja fica em {{url}}. Os códigos QR, folhetos e links já impressos ou partilhados com o endereço antigo deixam de funcionar.',
      },
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL do restaurante no Lieferando',
    },
    primary_color: {
      label: 'Cor primária',
    },
    logo: {
      label: 'Logótipo',
    },
    image: {
      label: 'Imagem',
    },
    companies: {
      label: 'Restaurantes',
    },
    noscripts: {
      description: 'Inserir código imediatamente após abrir o body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'ID Google Analytics',
    },
    google_ads_conversion_label_id: {
      label: 'Etiqueta de conversão Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Domínio próprio para a loja online',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Fechar',
    sync_from_lieferando: 'Sincronizar com Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Alterações guardadas com sucesso!',
    failed_to_update_company_slug: 'Falha ao atualizar slug para {{name}}',
    failed_to_sync_lieferando: 'Falha ao sincronizar detalhes do Lieferando',
    successfully_synced_lieferando: 'Dados sincronizados com sucesso do Lieferando',
    failed_to_load_shop_domains: 'Não foi possível carregar os domínios da loja.',
  },
};
